// Temporary App Store release flags. Set these back to true to restore the tabs.
export const TEMPORARY_TAB_FLAGS = {
  showStatusReview: false,
  showLearn: false,
} as const;
